export function parseUrl(
  url: string,
  routeParams: Record<string, string | undefined> = {}
): {
  baseUrl: string;
  appName?: string;
  module?: string;
  pathParams?: Record<string, string | undefined>;
  queryParams?: Record<string, string | undefined>;
} {
  try {
    const urlObj = new URL(url);
    const baseUrl = `${urlObj.protocol}//${urlObj.host}`;
    const pathSegments = urlObj.pathname.split('/').filter(Boolean);
    const appName = pathSegments.length > 0 ? pathSegments[0] : undefined;
    const module = pathSegments.length > 1 ? pathSegments[1] : undefined;

    const pathParamsResult =
      Object.keys(routeParams).length > 0 ? routeParams : undefined;

    const queryParams: Record<string, string | undefined> = {};
    urlObj.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    return {
      baseUrl,
      appName,
      module,
      pathParams: pathParamsResult,
      queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined
    };
  } catch (error) {
    console.error('Failed to parse URL', { url, error });
    return {
      baseUrl: typeof window !== 'undefined' ? window.location.origin : ''
    };
  }
}
